import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost'
  size?: 'md' | 'lg'
  children: ReactNode
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      className={cn(
        'inline-flex items-center justify-center font-medium rounded-card transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-mint focus:ring-offset-2 focus:ring-offset-chalk disabled:opacity-50 disabled:cursor-not-allowed',
        size === 'lg' ? 'px-6 py-3 text-base' : 'px-5 py-2.5 text-sm',
        variant === 'primary' &&
          'bg-mint text-navy hover:bg-mint/90 active:bg-mint/80 shadow-card',
        variant === 'secondary' &&
          'bg-navy text-white hover:bg-navy/90 active:bg-navy/80 shadow-card',
        variant === 'ghost' &&
          'bg-transparent text-navy hover:bg-mist active:bg-mist/70',
        className
      )}
    >
      {children}
    </button>
  )
}
